import {MediaFormatFamilies} from '../constants';

export const isMediaFileTypeAsset = (fileFormatFamily?: string[]) =>
	!!fileFormatFamily &&
	fileFormatFamily.some((format) =>
		MediaFormatFamilies.includes(
			format as (typeof MediaFormatFamilies)[number],
		),
	);

export default isMediaFileTypeAsset;
